import { markupFormatter } from '../common/markup/markupFormatter';
import { getPlainText } from '../common/utils/getPlainText';

export function cardQuestionText(markup: string): string {
    return getPlainText(markupFormatter.parse(markup).question);
}
